module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/87EhDX/tc-custom/9781466801295.jpg?1738254552638",
      "alt": "This image is the cover for the book Mighty Old Bones, Thistle & Twigg Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mighty Old Bones, Thistle & Twigg Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jane Thistle and Phoebe Twigg are as different as two best friends can be. Phoebe has never seen any reason to leave her small Southern hometown, while Jane, the urbane widow of a career military officer, has traveled all over, only recently putting down roots in Tullulah, Alabama."), _c('br'), _c('br'), _vm._v("At times, Tullulah can be a sleepy little town, but no one sleeps through the thunderstorm that knocks down a tree on Jane's property and uncovers a pile of skeletal remains buried underneath. Jane has some archaeological experience, thanks to all her travels, and knows a few experts. She invites an old friend to come down to Tullulah to have a look and catch up on old times. When tests discount their best theories and point to a far more recent death, Jane and Phoebe find themselves in the midst of some strange happenings."), _c('br'), _c('br'), _vm._v("Mary Saums's "), _c('i', [_vm._v("Mighty Old Bones,")]), _vm._v(" the second in this delightful series, rattles Alabama with two of the newest and unlikeliest sleuths throughout the southlands.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mary Saums\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Minotaur\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0